import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/shared/shared.module';
import { StorageService } from 'src/app/core/storage/storage.service';
import { CampaignTypes } from 'src/app/shared/model/campaign.enum';
import { VehiclesService } from 'src/app/core/services/vehicles.service';
import { User } from 'src/app/shared/model/user.model';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackModalComponent } from '../../../feedback-modal/feedback-modal.component';
import i18next from 'i18next';
import { RequestType } from 'src/app/shared/model/requestType.enum';

@Component({
  standalone: true,
  selector: 'app-step-summary',
  templateUrl: './step-summary.component.html',
  styleUrls: ['./step-summary.component.scss'],
  imports: [CommonModule, I18NextModule, MatIconModule, SharedModule]
})
export class StepSummaryComponent implements OnInit {
  @Input() car: any;
  @Input() campaign?: any;
  @Input() campaignType?: string;
  @Input() additionalInfo: any;
  @Input() user?: User;
  @Input() docInfo?: any;
  @Input() requestType?: string;
  @Output() onResponse: EventEmitter<any> = new EventEmitter<any>();
  substitutionVehicle: any;
  campaignTypeEnum = CampaignTypes;
  retribution = '';
  retributionText = '';
  requestTypeEnum = RequestType;

  constructor(
    private storageService: StorageService,
    private vehicleService: VehiclesService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.substitutionVehicle = this.storageService.get('substitutionVehicle');
    if (!!this.user) {
      this.vehicleService
        .getVehiclesRetribution(
          this.user.nis,
          !!this.substitutionVehicle ? this.substitutionVehicle.VIN : null,
          this.storageService.get('requestCarType') ===
            'endowmentLeasingLeasing'
            ? 'LEASING'
            : 'ENDOWMENT'
        )
        .subscribe({
          next: (resp) => {
            this.retribution = resp.response;
            return this.retributionTranslation(this.retribution);
          },
          error: () => {
            return (this.retributionText = '');
          }
        });
    }
  }

  retributionTranslation(retribution: string): string {
    return retribution === 'PRIMARY'
      ? (this.retributionText = i18next.t('primary'))
      : retribution === 'PRIMARY_ENDOWMENT'
        ? (this.retributionText = i18next.t('primaryEndowment'))
        : retribution === 'SECONDARY_ENDOWMENT'
          ? (this.retributionText = i18next.t('secondaryEndowment'))
          : (this.retributionText = i18next.t('secondary'));
  }

  translateFuelType(fuelType: string) {
    return i18next.t(fuelType);
  }

  response(confirm: boolean): void {
    const confirmation =
      confirm && !!this.campaign && !!this.campaign.retribution;
    const difRetribution =
      (this.campaign?.retribution === 'PRIMARY' &&
        this.retribution === 'SECONDARY') ||
      (this.campaign?.retribution === 'SECONDARY' &&
        this.retribution !== 'SECONDARY');

    if (confirmation && difRetribution) {
      this.dialog.open(FeedbackModalComponent, {
        width: '400px',
        data: {
          text: i18next.t('notRequestCampaignRetribution'),
          close: true,
          theme: 'ligth'
        }
      });
    } else {
      this.onResponse.emit({ confirm, retribution: this.retribution });
    }
  }

  calculateTotalFee(car: any): string {
    const parseNumber = (value: any): number => {
      if (typeof value === 'number') return value;
      if (typeof value === 'string') {
        const cleaned = value.replace(/[^\d,.-]/g, '').replace(',', '.');
        return parseFloat(cleaned) || 0;
      }
      return 0;
    };

    const leasing = parseNumber(car?.prices?.leasingRE);
    let fee;
    if (car?.prices?.fee) {
      fee = parseNumber(car?.prices?.fee);
    } else {
      fee = parseNumber(car?.price);
    }
    const total = leasing + fee;

    return (
      total.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' €'
    );
  }
}
